/**
 * Development Approach — frontend behaviour.
 *
 * Blur-reveal the header, then stagger the cards in. Loaded as an ES module
 * only on pages where this block renders.
 */
import './style.scss';
import { gsap } from 'gsap';

function init() {
	const sections = document.querySelectorAll('[data-dev-approach]');
	if (!sections.length) return;

	const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	sections.forEach((section) => {
		const head = section.querySelectorAll('[data-dev-approach-anim]');
		const cards = section.querySelectorAll('[data-dev-approach-card]');
		const targets = [...head, ...cards];
		if (!targets.length) return;

		if (reduced) {
			targets.forEach((el) => { el.style.opacity = '1'; el.style.transform = 'none'; });
			return;
		}

		gsap.set(targets, { opacity: 0, y: 24, filter: 'blur(10px)' });

		const io = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				io.unobserve(entry.target);
				gsap.to(head, {
					opacity: 1, y: 0, filter: 'blur(0px)',
					duration: 0.8, ease: 'power3.out', stagger: 0.1,
				});
				gsap.to(cards, {
					opacity: 1, y: 0, filter: 'blur(0px)',
					duration: 0.8, ease: 'power3.out', stagger: 0.12, delay: 0.15,
					// HOUSE PATTERN: drop the leftover inline transform so the
					// card :hover translateY lift isn't pinned by GSAP.
					clearProps: 'transform',
				});
			});
		}, { rootMargin: '0px 0px -15% 0px', threshold: 0.1 });

		io.observe(section);
	});
}

if (document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', init);
